import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { getBillingFieldPaths, getBillingSettings } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const TrackingOption2 = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData, mode } = useCompanyForm();
    const billingFieldPaths = getBillingFieldPaths(mode);
    const billingSettings = getBillingSettings(formData, mode);
    const handleChange = (e) => {
        updateFormData(billingFieldPaths.TRACKING_OPTION_2, e.target.value);
    };
    const hasError = !!errors?.trackingOption2 && touched?.trackingOption2;
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Tracking Option 2
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id="trackingOption2"
                        name="trackingOption2"
                        value={billingSettings?.trackingOption2 || ''}
                        onChange={handleChange}
                        placeholder="Tracking Option 2"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter tracking option 2 for this company"
                        ariaLabel="trackingoption2-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default TrackingOption2;
